/** Caps primary pill CTAs (dropzone “Select…”, Transcribe, Start recording, etc.) so they don’t span the full panel. */
export const SCRIBE_PRIMARY_CTA_MAX_WIDTH_PX = 440;

export const scribePrimaryCtaContainerSx = {
  width: `min(100%, ${SCRIBE_PRIMARY_CTA_MAX_WIDTH_PX}px)`,
  alignSelf: "center",
  mx: "auto",
} as const;
